import { BrowserRouter as Router } from "react-router-dom";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { RepositoryProvider } from "./repositories/RepositoryProvider";
import { PlatformTenantProvider } from "./contexts/PlatformTenantContext";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { GlobalProgress } from "./components/ui/GlobalProgress";
import { AnimatedRoutes } from "./components/layout/AnimatedRoutes";
import "./App.css";

function App() {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isLoading = isFetching > 0 || isMutating > 0;

  return (
    <ErrorBoundary>
      <RepositoryProvider>
        <AuthProvider>
          <PlatformTenantProvider>
            <OrganizationProvider>
              <ToastProvider>
                <Router>
                  <GlobalProgress isLoading={isLoading} />
                  <AnimatedRoutes />
                </Router>
              </ToastProvider>
            </OrganizationProvider>
          </PlatformTenantProvider>
        </AuthProvider>
      </RepositoryProvider>
    </ErrorBoundary>
  );
}

export default App;
